import { render, staticRenderFns } from "./SharingInformationStep.vue?vue&type=template&id=543a3a54&"
import script from "./SharingInformationStep.vue?vue&type=script&lang=js&"
export * from "./SharingInformationStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VStepperContent})
